import React from "react";
import { useParams } from "react-router-dom";
import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import { AlarmCenterContent } from "../../components/CompanyAdmin/Alarm/AlarmCenterContent";

const AlarmCenter: React.FC = () => {
  const { companyId } = useParams();
  return (
    <CompanyAdminLayout>
      <AlarmCenterContent companyId={companyId} />
    </CompanyAdminLayout>
  );
};

export default AlarmCenter;
